import { IApiSettings } from  "@/interfaces/IHttp";
import { injectable } from "inversify";

@injectable()
export class ApiSettings implements IApiSettings {

    public authTokenUrl() {
        return `/token`;
    }
        
    public apiBaseUrl() {
        // Development mode
        if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
            return 'http://tab.theappbuilder.local:2228/api/'

        }

        return `/api/`;  
    }

}  